import { useTheme } from "@mui/material";

import { DefaultPaper } from "@aclymatepackages/atoms";

const GrayPaper = ({ shade = "main", style = {}, children, ...otherProps }) => {
  const { palette } = useTheme();
  return (
    <DefaultPaper
      style={{ backgroundColor: palette.backgroundGray[shade], ...style }}
      elevation={0}
      {...otherProps}
    >
      {children}
    </DefaultPaper>
  );
};
export default GrayPaper;
